import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Box, Alert, Typography } from '@mui/material';
import CourseDetails from '../CourseDetails';

const CoursePreviewWrapper: React.FC = () => {
    const { courseId } = useParams<{ courseId: string }>();
    // We don't strictly need to read params here as CourseDetails reads them too,
    // but we might want to do some admin-specific validation later.

    return (
        <Box>
            <Alert
                severity="info"
                sx={{
                    borderRadius: 0,
                    mb: 0,
                    borderBottom: '1px solid #e0e0e0',
                    justifyContent: 'center',
                    '& .MuiAlert-message': { width: '100%', textAlign: 'center' }
                }}
            >
                <Typography variant="body2" component="span" fontWeight="bold">
                    Student View Preview Mode:
                </Typography>
                {' '} You are viewing this course as a student. Progress is not saved.
            </Alert>
            <CourseDetails preview={true} />
        </Box>
    );
};

export default CoursePreviewWrapper;
